import { parseAsPageNumber } from '@shared/utils';
import { parseAsArrayOf, parseAsInteger, parseAsString, useQueryStates } from 'nuqs';

const DEFAULT_PAGE_SIZE = 20;

export default function useSearchByQIDsParams() {
  return useQueryStates({
    qIds: parseAsArrayOf(parseAsString).withDefault([]),
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsInteger.withDefault(DEFAULT_PAGE_SIZE),
  });
}
